import Homepage from "view/FrontEnd/HomePage/Homepage";
import LayoutFront from "view/FrontEnd/LayoutFront/LayoutFront";

import Dashboard from "view/FrontEnd/Dashboard/Dashboard";
import PublishedDocuments from "view/FrontEnd/PublishedDocuments/PublishedDocuments";
import Gallery from "view/FrontEnd/Gallery/Gallery";
import Privacypolicy from "view/Cookie/Privacypolicy";
import ApplyMember from "view/FrontEnd/ApplyMember/ApplyMember";
import EmailOTP from "view/FrontEnd/ApplyMember/EmailOTP";
import AboutUs from "view/FrontEnd/HomePage/components/Contact";
import Register from "view/FrontEnd/HomePage/components/Register";
import Searchsite from "view/FrontEnd/SearchSite/SearchSite";
import GalleryList from "view/FrontEnd/Gallery/GalleryList";
import GalleryDetail from "view/FrontEnd/Gallery/GalleryDetail";

import LayoutFrontProject from "view/FrontEnd/Project/LayoutFront/LayoutFrontProject";
import Project from "view/FrontEnd/Project/Project";
import ProjectRequestFrom from "view/FrontEnd/Project/ProjectRequestFrom";
import GalleryListImg from "view/FrontEnd/Gallery/GalleryList";
import IncomeDashboard from "view/FrontEnd/Dashboard/Income/IncomeDashboard";
import ProjectSupportDashboard from "view/FrontEnd/Dashboard/ProjectSupport/ProjectSupportDashboard";
import ExpenseDashboard from "view/FrontEnd/Dashboard/Expense/ExpenseDashboard";

const route = [
    {
        exact: true,
        path: "/",
        component: Homepage,
    },   
    {
		exact: true,
		path: "/Home",
		component: Homepage,
	},
	{
		exact: true,
		path: "/AboutUs",
		component: AboutUs,
		layout: LayoutFront,
	},
	{
		exact: true,
		path: "/Dashboard",
		component: Dashboard,
		layout: LayoutFront,
	},	
	{
		exact: true,
		path: "/PublishedDocuments",
		component: PublishedDocuments,
		layout: LayoutFront,
	},	
	{
		exact: true,
		path: "/Gallery",
		component: Gallery,
		layout: LayoutFront,
	},	
	{
		exact: true,
		path: "/Privacypolicy",
		component: Privacypolicy,
	},		
	{
		exact: true,
		path: "/ApplyMember",
		component: ApplyMember,
	},		
	{
		exact: true,
		path: "/EmailOTP",
		component: EmailOTP,
	},	
	{
		exact: true,
		path: "/Searchsite",
		component: Searchsite,
		layout: LayoutFront,
	},		
	{
		exact: true,
		path: "/GalleryListImg",
		component: GalleryListImg,
		layout: LayoutFront,
	},	
	{
		exact: true,
		path: "/GalleryDetail",
		component: GalleryDetail,
		layout: LayoutFront,
	},	
	{
		exact: true,
		path: "/Project",
		component: Project,
		layout: LayoutFrontProject,
	},		
	{
		exact: true,
		path: "/ProjectFrom",
		component: ProjectRequestFrom,
		layout: LayoutFrontProject,
	},		
	{
		exact: true,
		path: "/IncomeDashboard",
		component: IncomeDashboard,
		layout: LayoutFrontProject,
	},	
	{
		exact: true,
		path: "/ExpenseDashboard",
		component: ExpenseDashboard,
		layout: LayoutFrontProject,
	},
	{
		exact: true,
		path: "/ProjectSupportDashboard",
		component: ProjectSupportDashboard,
		layout: LayoutFrontProject,
	},	

	
		

]

export default route;